import Vue from 'vue'
import axios from 'axios';
import store from '@/vuex/store';
import { apiUrl, deviceType, orderSource } from '@/utils/env';
import { main } from '@/main';
import { error } from "@/utils/api";

const http = axios.create({
  timeout: 20000,
  withCredentials: false
});

http.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = `application/json;charset=utf-8`;
    // config.headers['Content-Type'] = `application/x-www-form-urlencoded`;
    Vue.prototype.source = axios.CancelToken.source();
    config.cancelToken = Vue.prototype.source.token;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
http.interceptors.response.use(
  success => {
    switch (success.data.Code) {
      case 17007:
        console.warn('登录已过期!');
        break;
      default:
        break;
    }
    return success;
  },
  error => {
    if (error.data) {
      switch (error.data.Code) {
        case 404:
          console.warn('请求地址有误或者参数错误!');
          break;
      }
    } else {
      error.data = {
        Code: 0
      };
    }
    return error
  }
);

const get = (url, option) => {
  let options = setOption(option);
  setLoading(option, 1);
  return new Promise((resolve, reject) => {
    let urls = url;
    if (options.useApiUrl) {
      urls = apiUrl + url;
    }
    http({
      url: urls,
      baseURL: apiUrl,
      method: 'get',
      headers: options.header,
      params: options.data,
    }).then((res) => {
      setLoading(option, 0);
      checkToast(options.showError, res);
      resolve(res.data);
    }, res => {
      setLoading(option, 0);
      sendError(urls, res);
      reject(res);
    })
  })
};

const post = (url, option) => {
  let options = setOption(option);
  setLoading(option, 1);
  return new Promise((resolve, reject) => {
    let urls = url;
    if (options.useApiUrl) {
      urls = apiUrl + url;
    }
    http({
      url: urls,
      baseURL: apiUrl,
      method: 'post',
      headers: options.header,
      data: options.data,
    }).then(res => {
      setLoading(option, 0);
      checkToast(options.showError, res);
      resolve(res.data);
    }, res => {
      setLoading(option, 0);
      sendError(urls, res);
      reject(res);
    })
  })
};

const getJson = (url, option) => {
  let options = setJsonOption(option);
  setLoading(option, 1);
  return new Promise((resolve, reject) => {
    let urls = url;
    if (Object.keys(options.resource).length > 0) {
      urls = urls + "/" + Object.values(options.resource).join("/")
    }
    http({
      url: urls,
      baseURL: apiUrl,
      method: 'get',
    }).then((res) => {
      setLoading(option, 0);
      checkToast(options.showError, res);
      resolve(res.data);
    }, res => {
      setLoading(option, 0);
      sendError(urls, res);
      reject(res);
    })
  })
};

//设置配置
const setOption = (option = {}) => {
  //header设置
  if (typeof (option.header) == "undefined") {
    option.header = {}
  }
   //let token = store.state.token;
  let token = localStorage.getItem('token');
  //let token ="7y5sVzLrfKdJCdj/I5FesmTGuM4pQZrPnkzAbnOzk9SlyplbYvSQWA=="
  if (token) {
    Object.assign(option.header, {
      'token': token
    });
  }
  //查询参数
  if (typeof (option.query) == "undefined") {
    option.query = {};
  }
  //资源定位参数
  if (typeof (option.resource) == "undefined") {
    option.resource = {};
  }
  //资源体
  if (typeof (option.data) == "undefined") {
    option.data = {};
  }
  //是否使用loading
  if (typeof (option.isLoading) == "undefined") {
    option.isLoading = false;
  }
  //loading文字
  if (typeof (option.loadContent) == "undefined") {
    option.loadContent = "加载中..";
  }
  //是否开启错误提示
  if (typeof (option.showError) == "undefined") {
    option.showError = true;
  }
  //是否使用apiUrl
  if (typeof (option.useApiUrl) == "undefined") {
    option.useApiUrl = true;
  }
  return option;
};

//设置配置
const setJsonOption = (option = {}) => {
  //资源定位参数
  if (typeof (option.resource) == "undefined") {
    option.resource = {};
  }
  //是否开启错误提示
  if (typeof (option.showError) == "undefined") {
    option.showError = true;
  }
  //是否使用apiUrl
  if (typeof (option.useApiUrl) == "undefined") {
    option.useApiUrl = true;
  }
  return option;
};

//0关闭，1开启
const setLoading = (option = {}, type) => {
  let flexible = Vue.prototype.flexible;
  if( flexible ){
    if (type) {
      if (option.isLoading) {
        flexible.showLoading({
          content: option.loadContent
        });
      }
    } else {
      if (option.isLoading) {
        flexible.hideLoading();
      }
    }
  }
};

//自动弹出错误提示
const checkToast = (isShow, res) => {
  let flexible = Vue.prototype.flexible;
  if( flexible ){
    if (isShow) {
      if(res){
        switch (res.data.Code) {
          case 100:
            break;
          case 0:
            break;
          case -102:
            flexible.showToast({
              type: 'fail',
              content: "非本人订单，无法操作！",
              duration: 2000
            });
            break;
          case 17007:
            localStorage.removeItem('token');
            flexible.showToast({
              content: '请登录/注册！',
              duration: 1200,
              success: ()=> {
                if (orderSource == 17) {
                  window.webkit.messageHandlers.openPage.postMessage(
                    JSON.stringify({ type: "app", url: "/LonginActivity" })
                  );
                } else if (orderSource == 16) {
                  dfpanda.openPage(
                    JSON.stringify({ type: "app", url: "/app/LonginActivity" })
                  );
                }
              }
            });
            break;
          case -400:
            flexible.confirm({
              title: "提示",
              content: "您有在租订单",
              confirmButtonText: "查看订单",
              cancelButtonText: "取消",
              success: result => {
                if (result.confirm) {
                  main.$router.replace({
                    path: "/orderList"
                  });
                }
              }
            });
            break;
          default:
            flexible.showToast({
              type: 'fail',
              content: res.data.Message || "通讯失败,请重试",
              duration: 2000
            });
            break;
        }
      } else {
        flexible.showToast({
          type: 'fail',
          content: "通讯失败,请重试",
          duration: 2000
        });
      }
    }
  }
};

const sendError = (urls, res) => {
  if (urls.indexOf("api/Log/Error") > 0) {
    return
  }
  error({
    data: {
      ServiceName: "租车H5",
      HostAddress: "-----------",
      Message: urls,
      Exception: JSON.stringify(res)
    },
    showError: false
  });
};


export {
  get,
  post,
  getJson
}
